var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "16px",
    viewBox: "0 0 8 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Facebook",
    transform: "translate(-8.000000, -3.000000)",
    fill: "#E32119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9777778,8.33333333 L15.4666667,8.33333333 L15.1555556,11 L12.9777778,11 L12.9777778,19 L9.75,19 L9.75,11 L8,11 L8,8.33333333 L9.75,8.33333333 L9.75,6.54166667 C9.75,5.37499417 10.0222195,4.49305854 10.5666667,3.89583333 C11.1111138,3.29860812 12.0185122,3 13.2888889,3 L15.4666667,3 L15.4666667,5.66666667 L14.1444444,5.66666667 C13.6518494,5.66666667 13.33426,5.74999917 13.1916667,5.91666667 C13.0490734,6.08333417 12.9777778,6.36110917 12.9777778,6.75 L12.9777778,8.33333333 Z",
    id: "path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.632e8cf92d5a49762b0d2595ec9d5307.svg";
export { ForwardRef as ReactComponent };